let countdown_bar = {
    init() {
        const ab_date_container = document.querySelectorAll('.countdown-banner__date');

        ab_date_container.forEach(function (item) {
            let ab_enddate = item.querySelector('.countdown-banner__end-date').innerText;
            let ab_daysleft = item.querySelector('.countdown-banner__days-left');
            let days_left = item.querySelector('.countdown-days-number');
            let hours_left = item.querySelector('.countdown-hours-number');
            let minutes_left = item.querySelector('.countdown-minutes-number');
            let seconds_left = item.querySelector('.countdown-seconds-number');

            // Set the date we're counting down to
            let countDownDate = new Date(ab_enddate);

            // Update the count down every 1 second
            let x = setInterval(function () {
                // Get today's date and time
                let now = countdown_bar.hongKongTime();

                // Find the distance between now and the count down date
                let distance = countDownDate.getTime() - now.getTime();
                // Time calculations for days, hours, minutes and seconds
                let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.ceil((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // Display the result in the element with id="demo"

                days_left.innerHTML = days;
                hours_left.innerHTML = hours;
                minutes_left.innerHTML = minutes;
                seconds_left.innerHTML = seconds;

                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(x);
                    ab_daysleft.innerHTML = "EXPIRED";
                }
            }, 1000);
        });
    },
    hongKongTime(date = null) {
        let dt = (date == null) ? new Date() : new Date(date);
        return new Date(dt.toLocaleString('en-US', { timeZone: 'Hongkong' }));
    }
}

document.addEventListener("DOMContentLoaded", function () {
    countdown_bar.init();
});